import {loading, stopLoading} from "../../helpers/loading";
import {handleAjaxSuccess} from "../../helpers/swalHelper";
import {ProductionForm} from "./ProductionForm";

function initProductionCreate() {

	this.form = new ProductionForm({
		formElement: document.querySelector('.production-form'),
	});

	const urlCallback = document.querySelector('input[name="success_url"]').value;

	document.querySelector('.create-new-production-button')
		.addEventListener('click', () => {
			loading();
			this.form.submit()
				.then( response => {
					handleAjaxSuccess(response, () => {
						loading()
						window.location = urlCallback;
					})
						/*.then( () => {
							this.hide();
							this.notifySuccessListeners();
						});*/
				})
				.finally(stopLoading);

		});
}

export {initProductionCreate}
